import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { useMissionStore } from "@/store/modules/mission";
import InvestigationSynthesis from "@/models/interpretation/InvestigationSynthesis";
import { investigationSynthesesApi } from "@/api/interpretationClient";

const InvestigationSynthesisRepo = useRepo(InvestigationSynthesis);

export const useInvestigationSynthesisStore = defineStore("investigationSynthesis", {
  state: () => ({
    investigationSynthesis: null,
  }),

  getters: {
    getCurrentInvestigationSynthesis: (state) => {
      return state.investigationSynthesis;
    },
  },

  actions: {
    async fetchInvestigationSynthesis() {
      await InvestigationSynthesisRepo.flush();

      try {
        const missionsStore = useMissionStore();
        const response = await investigationSynthesesApi.list({
          projectId: missionsStore.currentMissionUuid,
          pageSize: 1,
        });

        if (response.results && response.results.length > 0) {
          this.investigationSynthesis = InvestigationSynthesisRepo.save(response.results[0]);
        } else {
          this.investigationSynthesis = null;
        }

        return this.investigationSynthesis;
      } catch (error) {
        console.error("Error fetching investigation synthesis:", error);
        throw error;
      }
    },

    async createInvestigationSynthesis(investigationSynthesis) {
      try {
        const missionsStore = useMissionStore();
        const projectId = missionsStore.currentMissionUuid;

        const investigationSynthesisRequest = {
          ...investigationSynthesis,
          project: projectId,
        };

        const response = await investigationSynthesesApi.create({
          investigationSynthesisRequest,
        });
        InvestigationSynthesisRepo.save(response);
        this.investigationSynthesis = response;

        return response;
      } catch (error) {
        console.error("Error creating investigation synthesis:", error);
        throw error;
      }
    },

    async updateInvestigationSynthesis(investigationSynthesis) {
      try {
        const { uuid, ...investigationSynthesisRequest } = investigationSynthesis;

        const response = await investigationSynthesesApi.update({
          uuid,
          investigationSynthesisRequest,
        });
        InvestigationSynthesisRepo.save(response);
        this.investigationSynthesis = response;

        return response;
      } catch (error) {
        console.error("Error updating investigation synthesis:", error);
        throw error;
      }
    },

    async partialUpdateInvestigationSynthesis(investigationSynthesis) {
      const { uuid, ...patchedInvestigationSynthesisRequest } = investigationSynthesis;

      const response = await investigationSynthesesApi.partialUpdate({
        uuid,
        patchedInvestigationSynthesisRequest,
      });
      if (response) {
        this.investigationSynthesis = InvestigationSynthesisRepo.save(response);
        return this.investigationSynthesis;
      }

      return null;
    },
  },
});
